// extracted by mini-css-extract-plugin
export default {"container":"EditorView_container__mN4YL","button":"EditorView_button__rjmHL","btncontainer":"EditorView_btncontainer__gsA0B","btnc":"EditorView_btnc__dDTdE"};